<template>
<div class="container">
  <div class="row">
    <div class="col">
      <h1>Details</h1>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h2>What Do my Clients See</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Your Name</p>
    </div>
    <div class="col-md-9 my-auto">
      <input v-model="name" class="form-control form-control-md">
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Brokerage Name</p>
    </div>
    <div class="col-md-9 my-auto">
      <input v-model="brokerageName" class="form-control form-control-md">
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Brokerage Color</p>
    </div>
    <div class="col-md-9 my-auto">
      <div class="input-group" ref="backgroundColorPicker">
        <input type="text" v-model="backgroundColorValue" v-on:focus="showBackgroundColorPicker()" v-on:input="updateBackgroundColorFromInput" class="form-control">
        <div class="input-group-append">
          <div class="input-group-text pointer-cursor" v-on:click="toggleBackgroundColorPicker()">
            <div class="current-color" v-bind:style="'background-color: ' + backgroundColorValue"></div>
          </div>
          <color-picker v-if="displayBackgroundColorPicker" v-bind:value="backgroundColors" v-on:input="updateBackgroundColorFromPicker" class="color-picker"></color-picker>
        </div>
      </div>
    </div>
  </div>
  <!-- TODO -->
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Text Color</p>
    </div>
    <div class="col-md-9 my-auto">
      <div class="input-group" ref="textColorPicker">
        <input type="text" v-model="textColorValue" v-on:focus="showTextColorPicker()" v-on:input="updateTextColorFromInput" class="form-control">
        <div class="input-group-append">
          <div class="input-group-text pointer-cursor" v-on:click="toggleTextColorPicker()">
            <div class="current-color" v-bind:style="'background-color: ' + textColorValue"></div>
          </div>
          <color-picker v-if="displayTextColorPicker" v-bind:value="textColors" v-on:input="updateTextColorFromPicker" class="color-picker"></color-picker>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Customer Contact Phone Number</p>
    </div>
    <div class="col-md-9 my-auto">
      <input v-model="phoneNumber" class="form-control form-control-md">
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Customer Contact Email</p>
    </div>
    <div class="col-md-9 my-auto">
      <input v-model="email" class="form-control form-control-md">
    </div>
  </div>
  <div class="row no-bottom-margin">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Profile Picture</p>
    </div>
    <div class="col-md-9 my-auto">
      <label class="custom-file-label" for="customFile">Upload file</label>
      <input class="custom-file-input" id="customFile" type="file" accept="image/png, image/jpeg" v-on:change="previewImage">
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
    </div>
    <div class="col-md-9 my-auto">
      <div class="preview-container">
        <img class="preview-image" v-bind:src="getProfilePicture" v-on:click="updateProfilePicture(null)" height="100px">
        <circle-enclosed-x-button v-if="getProfilePicture" v-on:x-button-clicked="updateProfilePicture(null)" class="preview-button"></circle-enclosed-x-button>
      </div>
    </div>
  </div>
  <div class="row no-bottom-margin">
    <div class="col-md-3 text-right my-auto">
      <p class="no-margin-bottom">Brokerage Picture</p>
    </div>
    <div class="col-md-9 my-auto">
      <label class="custom-file-label" for="customFile2">Upload file</label>
      <input class="custom-file-input" id="customFile2" type="file" accept="image/png, image/jpeg" v-on:change="previewImage2">
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 text-right my-auto">
    </div>
    <div class="col-md-9 my-auto">
      <div class="preview-container">
        <img class="preview-image" v-bind:src="getBrokeragePicture" v-on:click="updateBrokeragePicture(null)" height="100px">
        <circle-enclosed-x-button v-if="getBrokeragePicture" v-on:x-button-clicked="updateBrokeragePicture(null)" class="preview-button"></circle-enclosed-x-button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-4 offset-lg-4">
      <button v-on:click="updateRealtor()" class="btn btn-primary">Save</button>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Chrome } from 'vue-color'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import CircleEnclosedXButton from '../../general/buttons/CircleEnclosedXButton.vue'

export default {
  components: {
    'color-picker': Chrome,
    CircleEnclosedXButton,
    Loading
  },
  data () {
    return {
      backgroundColors: {
        hex: '#000000'
      },
      displayBackgroundColorPicker: false,
      displayTextColorPicker: false,
      textColors: {
        hex: '#000000'
      },
      loading: false
    }
  },
  methods: {
    ...mapActions('user', [
      'getCurrentUserData'
    ]),
    ...mapActions('realtor', [
      'putRealtorData'
    ]),
    ...mapMutations('realtor', [
      'updateBrokerageName',
      'updateBrokeragePicture',
      'updateLicenseNumber',
      'updatePhoneNumber',
      'updateProfilePicture',
      'updateRealtorBackgroundColor',
      'updateRealtorCode',
      'updateRealtorCognitoId',
      'updateRealtorEmail',
      'updateRealtorName',
      'updateRealtorTextColor'
    ]),
    ...mapMutations('user', [
      'updateMyRealtorCode'
    ]),
    previewImage: function (event) {
      var input = event.target
      var that = this
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = function (e) {
          if (!that.profilePicture || (that.profilePicture && !that.profilePicture.includes(e.target.result))) {
            var img = new Image()
            img.onload = function () {
              if (this.width > 150 && this.height > 150) {
                that.updateProfilePicture(e.target.result)
              } else {
                that.imageTooSmall = true
              }
            }
          }
          img.src = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }

      var fileInput = document.getElementById('customFile')
      fileInput.value = null
    },
    previewImage2: function (event) {
      var input = event.target
      var that = this
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = function (e) {
          if (!that.brokeragePicture || (that.brokeragePicture && !that.brokeragePicture.includes(e.target.result))) {
            var img = new Image()
            img.onload = function () {
              if (this.width > 150 && this.height > 150) {
                that.updateBrokeragePicture(e.target.result)
              } else {
                that.imageTooSmall = true
              }
            }
          }
          img.src = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }

      var fileInput = document.getElementById('customFile2')
      fileInput.value = null
    },
    updateBackgroundColorFromInput (picker) {
      this.updateBackgroundColors(this.backgroundColorValue)
    },
    updateTextColorFromInput (picker) {
      this.updateTextColors(this.textColorValue)
    },
    updateBackgroundColorFromPicker (color) {
      this.backgroundColors = color
      if (color.rgba.a === 1) {
        this.backgroundColorValue = color.hex
      } else {
        this.backgroundColorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')'
      }
    },
    updateTextColorFromPicker (color) {
      this.textColors = color
      if (color.rgba.a === 1) {
        this.textColorValue = color.hex
      } else {
        this.textColorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')'
      }
    },
    updateBackgroundColors (color) {
      if (color.slice(0, 1) === '#') {
        this.backgroundColors = {
          hex: color
        }
      } else if (color.slice(0, 4) === 'rgba') {
        var rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',')
        var hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1)
        this.backgroundColors = {
          hex: hex,
          a: rgba[3]
        }
      }
    },
    updateTextColors (color) {
      if (color.slice(0, 1) === '#') {
        this.textColors = {
          hex: color
        }
      } else if (color.slice(0, 4) === 'rgba') {
        var rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',')
        var hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1)
        this.textColors = {
          hex: hex,
          a: rgba[3]
        }
      }
    },
    hideBackgroundColorPicker () {
      document.removeEventListener('click', this.documentClickForBackgroundColorPicker)
      this.displayBackgroundColorPicker = false
    },
    hideTextColorPicker () {
      document.removeEventListener('click', this.documentClickForTextColorPicker)
      this.displayTextColorPicker = false
    },
    showBackgroundColorPicker () {
      document.addEventListener('click', this.documentClickForBackgroundColorPicker)
      this.displayBackgroundColorPicker = true
    },
    showTextColorPicker () {
      document.addEventListener('click', this.documentClickForTextColorPicker)
      this.displayTextColorPicker = true
    },
    toggleBackgroundColorPicker () {
      this.displayBackgroundColorPicker ? this.hideBackgroundColorPicker() : this.showBackgroundColorPicker()
    },
    toggleTextColorPicker () {
      this.displayTextColorPicker ? this.hideTextColorPicker() : this.showTextColorPicker()
    },
    documentClickForBackgroundColorPicker (e) {
      var el = this.$refs.backgroundColorPicker
      var target = e.target
      if (el !== target && !el.contains(target)) {
        this.hideBackgroundColorPicker()
      }
    },
    documentClickForTextColorPicker (e) {
      var el = this.$refs.textColorPicker
      var target = e.target
      if (el !== target && !el.contains(target)) {
        this.hideTextColorPicker()
      }
    },
    async updateRealtor () {
      this.loading = true
      try {
        this.$global.gaEvent('realtorUpdateData', 'backendCall')
        await this.putRealtorData({ code: this.getRealtorCode })
        this.getCurrentUserData()
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    }
  },
  computed: {
    ...mapGetters([
      'getCognitoId',
      'getIdProvider'
    ]),
    ...mapGetters('realtor', [
      'getBrokerageName',
      'getBrokeragePicture',
      'getLicenseNumber',
      'getPhoneNumber',
      'getProfilePicture',
      'getRealtorBackgroundColor',
      'getRealtorCode',
      'getRealtorEmail',
      'getRealtorName',
      'getRealtorTextColor'
    ]),
    brokerageName: {
      get () {
        return this.getBrokerageName
      },
      set (value) {
        this.updateBrokerageName(value)
      }
    },
    brokeragePicture: {
      get () {
        return this.getBrokeragePicture
      },
      set (value) {
        this.updateBrokeragePicture(value)
      }
    },
    backgroundColorValue: {
      get () {
        return this.getRealtorBackgroundColor
      },
      set (value) {
        this.updateRealtorBackgroundColor(value)
      }
    },
    licenseNumber: {
      get () {
        return this.getLicenseNumber
      },
      set (value) {
        this.updateLicenseNumber(value)
      }
    },
    email: {
      get () {
        return this.getRealtorEmail
      },
      set (value) {
        this.updateRealtorEmail(value)
      }
    },
    name: {
      get () {
        return this.getRealtorName
      },
      set (value) {
        this.updateRealtorName(value)
      }
    },
    phoneNumber: {
      get () {
        return this.getPhoneNumber
      },
      set (value) {
        this.updatePhoneNumber(value)
      }
    },
    profilePicture: {
      get () {
        return this.getProfilePicture
      },
      set (value) {
        this.updateProfilePicture(value)
      }
    },
    realtorName: {
      get () {
        return this.getRealtorName
      },
      set (value) {
        this.updateRealtorName(value)
      }
    },
    textColorValue: {
      get () {
        return this.getRealtorTextColor
      },
      set (value) {
        this.updateRealtorTextColor(value)
      }
    }
  },
  mounted () {
    this.$global.gaEvent('realtorViewDetails', 'navigation')
  }
}
</script>

<style scoped>
.phone-number >>> input {
  color: #495057;
}

.border-red {
  border-color: red;
}

.border-red:focus-within {
  border-color: #dc3545;
  box-shadow: 0 0 0 .2rem rgba(220,53,69,.25);
}

.container {
  margin-bottom: 3rem;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.no-margin-bottom {
  margin-bottom: 0px;
}

.row {
  margin-bottom: 1rem;
}

.red-text {
  color: red;
}

@media (max-width: 768px) {
  .text-right {
    text-align: left !important;
    padding-left: 1rem;
  }
}

.needs-margin-right {
  margin-left: .75rem;
}

.preview-button {
  cursor: pointer;
  left: 16px;
  position: absolute;
  top: 6px;
}

.preview-container {
  display: block;
  height: auto;
}

.preview-image {
  cursor: pointer;
  display: block;
  //margin: 0 auto !important;
  max-height: 300px;
}

.custom-file-input {
  line-height: 1.25;
}

.custom-file-label {
  margin-left: 15px;
  margin-right: 15px;
  line-height: 1.25;
}

.custom-file-label::after {
  line-height: 1.25;
}

.fix-custom-label {
  padding: 0;
  margin: 0 15px;
}

.color-picker {
  position: absolute;
  top: 39px;
  right: 15px;
  z-index: 3;
}

.current-color {
  display: inline-block;
  width: 16px;
  height: 16px;
}

.pointer-cursor {
  cursor: pointer;
}

.no-bottom-margin {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/realtorProfile/RealtorDetails.vue